define('bindingHandlers/validation/form',[
    'jquery',
    'lib/knockout',
    'lib/lodash4'
], function ($, ko, _) {
    'use strict';

    /**
     * Usage Examples
     *
     * <form data-bind="form: success">
     *     <input type="submit" />
     * </form>
     *
     * <form data-bind="form: { success: success, failure: failure, onSubmit: onSubmit }">
     *     <input type="submit" />
     * </form>
     *
     * In order to take advantage of the validation in the form binding, the form
     * should have an element data-bound with formGroup for each observable that
     * is being validated
     *
     * Each formGroup should have a controlMessage and optionally a formControl.
     *
     * The behavior of the form binding is that all observables bound to
     * contained formGroup observables will be validated on form submit.
     * The submit action will be cancelled and the formControl for the first
     * invalid formGroup will be focused.
     *
     */
    ko.bindingHandlers.form = {
        before: ['submit'],
        init: function (element, valueAccessor) {
            var value = valueAccessor();
            if (value) {
                var successCallback = value.success ? value.success : value;
                var failureCallback = value.failure;
                var onSubmit = value.onSubmit;
            }

            // Set element class.
            $(element).addClass('pc-form');

            // The form has a list of form-group observables that are part of it.
            ko.utils.domData.set(element, 'formGroupList', []);

            // When a form is submitted, all form groups in the list are considered to be modified.
            $(element).on('submit.form', function (e) {
                if(onSubmit) {
                    onSubmit.call(this, element);
                }

                e.preventDefault();

                var formGroupList = ko.utils.domData.get(element, 'formGroupList');

                // Mark each form group as modified. This will cause the errors to display.
                _.forEach(formGroupList, function (formGroup) {
                    if (formGroup.observable.isModified) {
                        formGroup.observable.isModified(true);
                    }
                });

                // See if there is an invalid form group.
                var firstInvalidFormGroup = _.find(formGroupList, function (formGroup) {
                    if (formGroup.observable.isValid) {
                        return !formGroup.observable.isValid();
                    }
                    return false;
                });

                // If a form group is invalid, focus it and cancel the submit binding from running.
                if (firstInvalidFormGroup) {

                    // Failure
                    if (failureCallback) {
                        failureCallback.call(this, element, formGroupList, firstInvalidFormGroup);
                    }

                    if (firstInvalidFormGroup.controlElement) {

                        // The defer allows the enterw Knockout stack to complete. The template rendering can remove an element
                        // and add it back in removing the correct focus.
                        _.defer(function () {
                            $(firstInvalidFormGroup.controlElement).focus();
                        });
                    }
                }
                else {

                    // Success
                    if (successCallback) {
                        successCallback.call(this, element);
                    }

                }
            });

            // Cleanup
            ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                ko.utils.domData.set(element, 'formGroupList', undefined);
                $(element).off('.form');
            });
        }
    };
});

